import catalog from './exam-catalog.json';
import type { Instant, LocalDate, RegistrationWindow } from './index';
export type CatalogExam = (typeof catalog)[number];
export type CatalogSchedule = CatalogExam['schedules'][number];
export const EXAM_CATALOG = catalog;
export function catalogExam(id?: string): CatalogExam | undefined {
  return catalog.find((exam) => exam.id === id?.split(':')[0]);
}
export function selectedCatalogSchedule(
  exam: CatalogExam,
  today: string,
  stage = exam.stages[0]!.id,
): CatalogSchedule & { provisional: boolean } {
  const dates = exam.schedules
    .filter((item) => item.stage === stage)
    .sort((a, b) => a.examDate.localeCompare(b.examDate));
  const upcoming = dates.find((item) => item.examEndsOn >= today);
  if (upcoming) return { ...upcoming, provisional: false };
  const first = dates[0]!;
  const year = Math.max(Number(today.slice(0, 4)), exam.dataYear + 1);
  const shift = (date: string) =>
    `${Number(date.slice(0, 4)) + year - exam.dataYear}${date.slice(4)}`;
  return {
    ...first,
    examDate: shift(first.examDate),
    examEndsOn: shift(first.examEndsOn),
    resultDate: shift(first.resultDate),
    registrationWindows: first.registrationWindows.map((window) => ({
      ...window,
      startsAt: shift(window.startsAt),
      endsAt: shift(window.endsAt),
      label: '임시 원서접수 · 공고 확인 필요',
    })),
    provisional: true,
  };
}
export function catalogRegistrationWindows(schedule: CatalogSchedule): RegistrationWindow[] {
  return schedule.registrationWindows.map((window) => ({
    ...window,
    startsAt: window.startsAt as Instant,
    endsAt: window.endsAt as Instant,
  }));
}
export function catalogDate(schedule: CatalogSchedule): LocalDate {
  return schedule.examDate as LocalDate;
}
